'use client';

import {useCallback} from 'react';

import styles from './LogoWallItem.module.scss';

export type LogoWallLogoProps = {
  logoSrc: string;
  href: string;
  isTargetBlank: boolean;
  index: number;
  onLogoClick?: (href: string, index: number) => void;
};

export const LogoWallItem = ({
  logoSrc,
  href,
  isTargetBlank,
  index,
  onLogoClick,
}: LogoWallLogoProps) => {
  const handleClick = useCallback(() => {
    onLogoClick && onLogoClick(href, index);
  }, []);

  return (
    <a
      href={href ?? ''}
      onClick={handleClick}
      target={isTargetBlank ? '_blank' : '_self'}
      tabIndex={-1}
      aria-hidden="true"
      className={styles.logoWallItem}
      style={{backgroundImage: `url(${logoSrc})`}}
    />
  );
};
